module.exports = __webpack_public_path__ + "img/close-white.0bfbd11a.svg";